import { render, staticRenderFns } from "./ImageSize.vue?vue&type=template&id=79f1b96d&scoped=true&"
import script from "./ImageSize.vue?vue&type=script&lang=js&"
export * from "./ImageSize.vue?vue&type=script&lang=js&"
import style0 from "./ImageSize.vue?vue&type=style&index=0&id=79f1b96d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f1b96d",
  null
  
)

export default component.exports